import { render, staticRenderFns } from "./sliding-block.vue?vue&type=template&id=6763007c&scoped=true&"
import script from "./sliding-block.vue?vue&type=script&lang=js&"
export * from "./sliding-block.vue?vue&type=script&lang=js&"
import style0 from "./sliding-block.vue?vue&type=style&index=0&id=6763007c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6763007c",
  null
  
)

export default component.exports